import { Link } from "react-router-dom";
import { scrollToTop } from "../../utils/Constants";
import "../../styles/pages/interview/_hub-tab.scss";

export default function HubTab() {
    return (
        <div className="hub-tab">
            <div className="tab-header">Career Hub</div>
            <div className="tab-subheading">add content</div>
        </div>
    );
}
